import type { OrderFilterDto } from "Infrastructure/Api/Api";
import type { QueryClient } from "@tanstack/react-query";
import { orderKeys } from "./orderKeys";

export async function invalidateOrderDetailBundle(
	queryClient: QueryClient,
	orderId: number,
) {
	await Promise.all([
		queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) }),
		queryClient.invalidateQueries({
			queryKey: orderKeys.partnerAllocations(orderId),
		}),
		queryClient.invalidateQueries({ queryKey: orderKeys.timeline(orderId) }),
		queryClient.invalidateQueries({ queryKey: orderKeys.comments(orderId) }),
		queryClient.invalidateQueries({ queryKey: orderKeys.price(orderId) }),
		queryClient.invalidateQueries({ queryKey: orderKeys.review(orderId) }),
		queryClient.invalidateQueries({
			queryKey: orderKeys.examinations(orderId),
		}),
		queryClient.invalidateQueries({ queryKey: orderKeys.attachments(orderId) }),
	]);
}

export async function invalidateOrderList(
	queryClient: QueryClient,
	filters?: Partial<OrderFilterDto>,
) {
	if (filters) {
		await queryClient.invalidateQueries({ queryKey: orderKeys.list(filters) });
	} else {
		await queryClient.invalidateQueries({ queryKey: orderKeys.listAll });
	}
}

export async function invalidateClaimsForOrder(
	queryClient: QueryClient,
	orderId: number,
) {
	await Promise.all([
		queryClient.invalidateQueries({
			queryKey: orderKeys.claimsByOrder(orderId),
		}),
		queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) }),
	]);
}

export async function invalidateOrderComments(
	queryClient: QueryClient,
	orderId: number,
) {
	await queryClient.invalidateQueries({
		queryKey: orderKeys.comments(orderId),
	});
}

export async function invalidatePartnerCalendar(queryClient: QueryClient) {
	await queryClient.invalidateQueries({ queryKey: ["partners", "calendar"] });
}

export async function invalidatePriceForOrder(
	queryClient: QueryClient,
	orderId: number,
) {
	await Promise.all([
		queryClient.invalidateQueries({ queryKey: orderKeys.price(orderId) }),
		queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) }),
		queryClient.invalidateQueries({ queryKey: orderKeys.fee(orderId) }),
	]);
}
